module.exports = __webpack_public_path__ + "img/company-updates-empty-image.ae6de52d.png";